import { Pipe, PipeTransform } from '@angular/core';
import { AppConfig } from '../global-variables';

@Pipe({
  name: 'appConfig'
})
export class AppConfigPipe implements PipeTransform {

  transform(value: string): unknown {
    return AppConfig[value];
  }

}
